// extracted by mini-css-extract-plugin
module.exports = {"text-headline":"Text_text-headline__F4YAA","text-content":"Text_text-content__PSJVU"};